import { all } from "redux-saga/effects";
import getInfomationStorePage from "./getInfomationStorePage";
import postUpdateInfomationStore from "./postUpdateInfomationStore";
import postUploadImageProfile from "./postUploadImageProfile";

export const infomationStorePageSaga = function* root() {
	yield all([
		getInfomationStorePage(),
		postUpdateInfomationStore(),
		postUploadImageProfile()
	]);
};
